export const prefixCls = 'yunti-ui';
